import React, { Component } from 'react'
import LoadMask from 'Utils/LoadMask/LoadMask';
import CardEmpty from '../../../../Utils/Cards/CardEmpty';
import CashFlowForm from './CashFlowForm';
import Tabs, { TabPane } from "rc-tabs";
import CashFlowFormAnnual from './Annual/CashFlowFormAnnual';
export default class CashFlowEdit extends Component {
    componentDidMount() {
        const { page } = this.props;
        if (this.props.tab === 'EN_CURSO') {
            this.props.getDollar();
            this.props.read(page);
        } else {
            this.props.readAnnual();
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.tab !== prevProps.tab) {
            if (this.props.tab === 'EN_CURSO') {
                this.props.getDollar();
                this.props.read();
            } else {
                this.props.readAnnual();
            }
        }
    }

    actualizar = (data) => {
        const id = data.id
        this.props.editar(id, data);
    };

    getPermissions = () => {
        const { getMe } = this.props;
        getMe();
    }

    render() {
        const { editar } = this.props;
        const { updateData, loader, item, setTab, tab } = this.props;
        return (
            <div className="mb-4 col-12 cash-flow">

                <Tabs
                    defaultActiveKey={tab}
                    activeKey={tab}
                    onChange={tab => setTab(tab)}
                    animated={{ tabPane: true, inkBar: true }}
                    moreIcon={<span className='icon-more-icon'>+</span>}
                >

                    <TabPane tab="EN CURSO" key="EN_CURSO">
                        <CardEmpty noShadow isMarginButtom>
                            <LoadMask loading={loader} blur>
                                <CashFlowForm
                                    onSubmit={this.actualizar}
                                    updateData={updateData}
                                    item={item}
                                    editando={true}
                                    permisos={this.getPermissions}
                                    {...this.props}
                                />
                            </LoadMask>
                        </CardEmpty>
                    </TabPane>
                    <TabPane tab="PROYECCIONES ANUALES" key="PROYECCIONES_ANUALES">
                        <CardEmpty noShadow isMarginButtom>
                            <LoadMask loading={loader} blur>
                                <CashFlowFormAnnual
                                    onSubmit={this.actualizar}
                                    updateData={updateData}
                                    item={item}
                                    editando={true}
                                    permisos={this.getPermissions}
                                    {...this.props}
                                />
                            </LoadMask>
                        </CardEmpty>
                    </TabPane>
                </Tabs>
            </div>
        )
    }
}